import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import {userType} from "../../shared/utils/enums";

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if(!auth.user) {
    router.navigateByUrl('/login')
    return false
  }
  if (auth.isTokenExpired()) {
    // Token is past its expiry: clear the stale session instead of letting
    // every API call fail with 401.
    auth.disconnect();
    return false;
  }
  return true;
};
